import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTabPanel from "./calculationPanels/utils/CustomTabPanel";
import KitchenUtensilCalculator from "./calculationPanels/KitchenUtensils";
import KitchenTypeCalculator from "./calculationPanels/BusinessAndNumberOfMeals";
import MeatProductionCalculator from "./calculationPanels/ButcherAndMeatProduction";

const CalculateQsModal = ({ open, onClose, handleSetQs, openSpecific }) => {
  const [tabValue, setTabValue] = useState(false);

  useEffect(() => {
    setTabValue(openSpecific);
  }, [openSpecific]);

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="calculation-modal"
      aria-describedby="calculation-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxWidth: 800,
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" component="h2">
            Kalkuler vannføring (Qs) med valgt metode
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          variant="subtitle1"
          sx={{ mb: 1, color: "text.secondary", fontStyle: "italic" }}
        >
          Vennligst velg en av metodene
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            <Tab label="Kjøkkenutstyr" {...a11yProps(0)} />
            <Tab label="Virksomhet og antall måltider" {...a11yProps(1)} />
            <Tab label="Slakter og kjøttproduksjon" {...a11yProps(2)} />
          </Tabs>
        </Box>

        {tabValue === false && (
          <Box sx={{ mt: 2, p: 2, bgcolor: "warning.light", borderRadius: 1 }}>
            <Typography variant="h6" sx={{ mb: 1, color: "warning.dark" }}>
              Vennligst velg en av metodene ovenfor for å kalkulere Qs:
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b> - Kjøkkenutstyr:</b> Beregn Qs basert på antall og type
              kjøkkenutstyr som brukes i virksomheten.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>- Virksomhet og antall måltider:</b> Beregn Qs basert på antall
              måltider som serveres og type virksomhet.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <b>- Slakter og kjøttproduksjon:</b> Beregn Qs basert på antall
              slaktere og mengde kjøtt som produseres.
            </Typography>
          </Box>
        )}

        <CustomTabPanel value={tabValue} index={0}>
          <KitchenUtensilCalculator handleSetQs={handleSetQs} />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <KitchenTypeCalculator handleSetQs={handleSetQs} />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <MeatProductionCalculator handleSetQs={handleSetQs} />
        </CustomTabPanel>
      </Box>
    </Modal>
  );
};

export default CalculateQsModal;
